<template>
    <div>
        <div class="menu-container">
            <i
                :id="sequence[0].id"
                @click="selectionEmoji(sequence[0].id)"
                class="icon far fa-grin-alt"
            ></i>
            <i
                :id="sequence[1].id"
                @click="selectionEmoji(sequence[1].id)"
                class="icon far fa-meh"
            ></i>
            <i
                :id="sequence[2].id"
                @click="selectionEmoji(sequence[2].id)"
                class="icon far fa-frown-open"
            ></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MenuHumor',
    data() {
        return {
            sequence: [
                {
                    id: '1Emoji',
                    active: false,
                    color: 'green',
                    value: 3,
                },
                {
                    id: '2Emoji',
                    active: false,
                    color: 'yellow',
                    value: 2,
                },
                {
                    id: '3Emoji',
                    active: false,
                    color: 'red',
                    value: 1,
                },
            ],
        }
    },
    methods: {
        selectionEmoji(sequence) {
            let item = document.getElementById(`${sequence}`)
            if (sequence == this.sequence[0].id) {
                document.getElementById('2Emoji').classList.remove('yellow')
                document.getElementById('3Emoji').classList.remove('red')
                this.$emit('valueSelected', this.sequence[0].value)
                return item.classList.add('green')
            }
            if (sequence == this.sequence[1].id) {
                document.getElementById('1Emoji').classList.remove('green')
                document.getElementById('3Emoji').classList.remove('red')
                this.$emit('valueSelected', this.sequence[1].value)
                return item.classList.add('yellow')
            }
            if (sequence == this.sequence[2].id) {
                document.getElementById('1Emoji').classList.remove('green')
                document.getElementById('2Emoji').classList.remove('yellow')
                this.$emit('valueSelected', this.sequence[2].value)
                return item.classList.add('red')
            }
        },
    },
}
</script>

<style lang="sass" scoped>
.menu-container
    display: flex
    align-items: center
    column-gap: 1rem
    font-size: 1.6rem
.green
    color: #359c61
.yellow
    color: #e7a42f
.red
    color: #de5b5b
.icon
    cursor: pointer
    transition: all 300ms ease-in-out
    &:hover
        transform: scale(1.2)
    &:active
        transform: scale(1.3)
</style>
